import React from 'react';
import { get } from 'lodash';


const Print = ({
	title = null,
	...rest
}) => (
	<svg
		width={get(rest, 'width', 16)}
		height={get(rest, 'height', 16)}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		{...rest}
		aria-hidden="true"
		focusable="false"
		data-prefix="far"
		data-icon="print"
		role="img"
	>
		{title ? <title>{title}</title> : null}
		<path fill="currentColor" d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"></path>
	</svg>
);

export default Print;
